import { render } from "./Dental.vue?vue&type=template&id=20aa0d63"
import script from "./Dental.vue?vue&type=script&lang=js"
export * from "./Dental.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__